import reducer from "./reducer"
export { reducer }
export const networkAvailable = state => state.network.networkAvailable



// WEBPACK FOOTER //
// ./src/Network/index.js